import React from "react";
import PaginatedTable from '../components/paginatedTable'

import StandardButton from "../components/standardButton";
import { GridActionsCellItem, GridRowModes } from "@mui/x-data-grid";
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/DeleteOutlined';
import SaveIcon from '@mui/icons-material/Save';
import CancelIcon from '@mui/icons-material/Close';
import NotificationsActiveIcon from '@mui/icons-material/NotificationsActive';

const items = [
  { id: 1, categoryName: 'AI', subcategoryList: 'Sector', sectors: "Grocery", areas: "Grocery", usedInCompany: 2121, sortOrders: 35,},
  { id: 2, categoryName: 'AI', subcategoryList: 'Sector', sectors: "Bakery", areas: "Bakery", usedInCompany: 2121, sortOrders: 42,},
  { id: 3, categoryName: 'AI', subcategoryList: 'Sector', sectors: "Grocery", areas: "Grocery", usedInCompany: 2121, sortOrders: 45,},
  { id: 4, categoryName: 'AI', subcategoryList: 'Sector', sectors: "Grocery", areas: "Grocery", usedInCompany: 2121, sortOrders: 16,},
  { id: 5, categoryName: 'AI', subcategoryList: 'Sector', sectors: "Grocery", areas: "Grocery", usedInCompany: 2121, sortOrders: 12,},
  { id: 6, categoryName: 'AI', subcategoryList: 'Sector', sectors: "Bakery", areas: "Bakery", usedInCompany: 2121, sortOrders: 150,},
  { id: 7, categoryName: 'AI', subcategoryList: 'Sector', sectors: "Grocery", areas: "Grocery", usedInCompany: 2121, sortOrders: 44,},
  { id: 8, categoryName: 'AI', subcategoryList: 'Sector', sectors: "Grocery", areas: "Grocery", usedInCompany: 2121, sortOrders: 36,},
  { id: 9, categoryName: 'AI', subcategoryList: 'Sector', sectors: "Bakery", areas: "Bakery", usedInCompany: 2121, sortOrders: 65,},
  { id: 10, categoryName: 'AI', subcategoryList: 'Sector', sectors: "Bakery", areas: "Bakery", usedInCompany: 2121, sortOrders: 35,},
  { id: 11, categoryName: 'AI', subcategoryList: 'Sector', sectors: "Grocery", areas: "Grocery", usedInCompany: 2121, sortOrders: 42,},
  { id: 12, categoryName: 'AI', subcategoryList: 'Sector', sectors: "Grocery", areas: "Grocery", usedInCompany: 2121, sortOrders: 45,},
  { id: 13, categoryName: 'AI', subcategoryList: 'Sector', sectors: "Bakery", areas: "Bakery", usedInCompany: 2121, sortOrders: 16,},
  { id: 14, categoryName: 'AI', subcategoryList: 'Sector', sectors: "Grocery", areas: "Grocery", usedInCompany: 2121, sortOrders: 12,},
  { id: 15, categoryName: 'AI', subcategoryList: 'Sector', sectors: "Grocery", areas: "Grocery", usedInCompany: 2121, sortOrders: 150,},
  { id: 16, categoryName: 'AI', subcategoryList: 'Sector', sectors: "Bakery", areas: "Bakery", usedInCompany: 2121, sortOrders: 44,},
  { id: 17, categoryName: 'AI', subcategoryList: 'Sector', sectors: "Grocery", areas: "Grocery", usedInCompany: 2121, sortOrders: 36,},
  { id: 18, categoryName: 'AI', subcategoryList: 'Sector', sectors: "Grocery", areas: "Grocery", usedInCompany: 2121, sortOrders: 65,},
];

export default function ManageKeywords() {
  const [rows, setRows] = React.useState(items);
  const [rowModesModel, setRowModesModel] = React.useState({});
  const header = [
    { field: 'categoryName', headerName: 'Category Name', width: 200 },
    { field: 'subcategoryList', headerName: 'Subcategory List', width: 130 },
    { field: 'sectors', headerName: 'Sectors', width: 200 },
    { field: 'areas', headerName: 'Areas', width: 200 },
    { field: 'usedInCompany', headerName: 'Used in Company', type: 'number', width: 120 },
    { field: 'sortOrders', headerName: 'Sort Orders', type: 'number', width: 120 },
    {
      field: 'actions',
      type: 'actions',
      headerName: 'Actions',
      width: 100,
      cellClassName: 'actions',
      getActions: ({ id }) => {
        const isInEditMode = rowModesModel[id]?.mode === GridRowModes.Edit;
  
        if (isInEditMode) {
          return [
            <GridActionsCellItem
              icon={<SaveIcon />}
              label="Save"
              sx={{
                color: 'primary.main',
              }}
              onClick={handleSaveClick(id)}
            />,
            <GridActionsCellItem
              icon={<CancelIcon />}
              label="Cancel"
              className="textPrimary"
              onClick={handleCancelClick(id)}
              color="inherit"
            />,
          ];
        }
  
        return [
          <GridActionsCellItem
            icon={<EditIcon />}
            label="Edit"
            className="textPrimary"
            onClick={handleEditClick(id)}
            color="inherit"
          />,
          <GridActionsCellItem
            icon={<DeleteIcon />}
            label="Delete"
            onClick={handleDeleteClick(id)}
            color="inherit"
          />,
        ];
      },
    }
  ];

  const handleEditClick = (id) => () => {
    setRowModesModel({ ...rowModesModel, [id]: { mode: GridRowModes.Edit } });
  };

  const handleSaveClick = (id) => () => {
    setRowModesModel({ ...rowModesModel, [id]: { mode: GridRowModes.View } });
  };

  const handleDeleteClick = (id) => () => {
    setRows(rows.filter((row) => row.id !== id));
  };

  const handleCancelClick = (id) => () => {
    setRowModesModel({
      ...rowModesModel,
      [id]: { mode: GridRowModes.View, ignoreModifications: true },
    });

    const editedRow = rows.find((row) => row.id === id);
    if (!!editedRow && editedRow.isNew) {
      setRows(rows.filter((row) => row.id !== id));
    }
  };

  return (
    <div className="p-5 flex justify-center items-center h-full max-h-[100vh]">
      <div className="p-5 flex items-center justify-center w-full h-full max-h-full bg-[#191919] rounded-2xl">
        <div className="flex flex-col gap-5 max-w-full max-h-full w-full h-full">
          
          <div className="flex justify-between items-center w-full">
            <h1 className="text-6xl font-medium">Manage Keywords</h1>
            <StandardButton text="Add new category" width="300px" variant="filled" />
          </div>
          <div className="flex gap-4 items-center">
            <NotificationsActiveIcon sx={{color: "rgb(var(--global-color-primary))"}}/>
            <span>SuperAdmin should be able to analyse and produce a report of the registered companies through its given keywords.</span>
          </div>
          <PaginatedTable header={header} items={items} />
        </div>
      </div>
    </div>
  )
}